import {Tag} from 'antd';
import React from 'react';

// 广告状态映射
const AD_STATUS_MAP: Record<number, { text: string; color: string }> = {
  0: {text: '草稿', color: 'default'},
  1: {text: '审核中', color: 'warning'},
  2: {text: '投放中', color: 'success'},
  3: {text: '已暂停', color: 'default'},
  4: {text: '已结束', color: 'default'},
  5: {text: '已拒绝', color: 'error'},
};

// 通用启用/禁用状态
const ENABLE_STATUS_MAP: Record<number, { text: string; color: string }> = {
  1: {text: '启用', color: 'success'},
  0: {text: '禁用', color: 'error'},
};

// 账户状态
const ACCOUNT_STATUS_MAP: Record<number, { text: string; color: string }> = {
  1: {text: '正常', color: 'success'},
  2: {text: '受限', color: 'warning'},
  3: {text: '禁用', color: 'error'},
};

interface StatusTagProps {
  status: number;
  type?: 'ad' | 'enable' | 'account';
}

const StatusTag: React.FC<StatusTagProps> = ({status, type = 'enable'}) => {
  let map = ENABLE_STATUS_MAP;
  if (type === 'ad') map = AD_STATUS_MAP;
  if (type === 'account') map = ACCOUNT_STATUS_MAP;

  const config = map[status] || {text: '未知', color: 'default'};
  return <Tag color={config.color}>{config.text}</Tag>;
};

export default StatusTag;
export {AD_STATUS_MAP, ENABLE_STATUS_MAP, ACCOUNT_STATUS_MAP};
